import Axios from "../../services/axios-service";
import AxiosAuth from "../../services/axios-service-auth";
import {getToken} from "../../services/user-service";

const login = data => {
  return AxiosAuth.post("/api/AuthV2/login", data, undefined);
};

const switchUser = (data) => {
  	const	token = getToken();
    return AxiosAuth.post('/api/AuthV2/switchuser', data, token);
};

const getUserData = (data) => {
	return Axios.get("/validateToken", data, undefined);
};

const getUserLinkedAccounts = () => {
  return Axios.get('/api/user/linkedaccounts/', undefined, undefined);
};

const getUserListing = (data) => {
  let _orgId = data.orgId;
  delete data.orgId;
  return Axios.get(
    '/api/OrganizationUsers/' + _orgId + '?search=' + encodeURIComponent(JSON.stringify(data)),
    undefined,
    undefined
  );
};


const getGlobalListing = (data) => {
    return Axios.get(
      '/api/GlobalUsers/' + '?search=' + encodeURIComponent(JSON.stringify(data)),
      undefined,
      undefined
    );
};

const getAgentListing = data => {
  let _orgId = data.orgId;
  delete data.orgId;
  return Axios.get("/api/GetOrganizationAgents/" + _orgId + "?search="+encodeURIComponent(JSON.stringify(data)), undefined, undefined);
};

const updateUser = data => {
  return Axios.put("/api/Users/"+data.userId, data, undefined);
};

const addUser = data => {
  return Axios.post("/api/Users", data, undefined);
};

const getUser = idx => {
  return Axios.get("/api/Users/"+idx, undefined, undefined);
};

const getAgent = idx => {
  return Axios.get("/api/GetAgent/"+idx, undefined, undefined);
};

const deleteUser = data => {
  return Axios.delete("/users/"+ data.userId, data, undefined);
};

const forgotPassword = data => {
  return AxiosAuth.get("/api/ForgotPassword", data, undefined);
};

const resetPassword = data => {
  return AxiosAuth.post("/api/ForgotPassword", data, undefined);
};

const getAllUserRoles = data => {
  return Axios.get("/api/Roles/InternalRoles?filters="+encodeURIComponent(JSON.stringify(data)), data, undefined);
};

const updateToken = data => {
  return AxiosAuth.post("/api/AuthV2/refreshtoken", data, undefined);
};

const updateProfile = data => {
  return Axios.put("/api/Users/"+data.userId, data, undefined);
};
const getMyAccount = async () => {
  return await Axios.get("/api/Users/Profile", undefined, undefined);
};
const updateMyAccount = async (data) => {
  return await Axios.put("/api/Users/Profile", data, undefined);
};
const updatePassword = async (data) => {
  return await Axios.post("/api/Users/updatePassword", data, undefined);
};
const updateStatus = (userId, status) => {
  return Axios.put("/api/UserStatus/"+userId+"/"+status, undefined, undefined);
};
const updateContactDetails = (data) => {
  return Axios.post("/api/UserContactDetails/", data, undefined);
};
const assignIdentity = data => {
  return Axios.post("/api/Users/AssignIdentity",data, undefined,undefined);
};
const getActiveInternalUsers = data => {
  let _orgId = data.orgId;
  delete data.orgId;
  return Axios.get("/api/OrganizationActiveUsers/" + _orgId + "?search="+encodeURIComponent(JSON.stringify(data)), undefined, undefined);
};
const hasB2B2CEmergencyContact = (userId) => {
  return Axios.get("/api/B2B2CEmergencyContactExists/"+userId, undefined, undefined);
};
const updateB2B2CEmergencyContact = (userId, data) => {
  return Axios.put("/api/UpdateB2B2CEmergencyContact/"+userId, data, undefined);
};
const getChildUserLocation = (userId) => {
  return Axios.get('/childUserLocations/' + userId, undefined, undefined);
};

const mfaSetup = data => {
  return AxiosAuth.post("/api/AuthV2/mfa/setup", data, undefined);
};

const mfaVerifyOtp = data => {
  return AxiosAuth.post("/api/AuthV2/mfa/verifyOtp", data, undefined);
};

const mfaSendEmailOtp = data => {
  return AxiosAuth.post("/api/AuthV2/mfa/sendEmailOtp", data, undefined);
};


export default {
  login,
  getUserData,
  getUserListing,
  getAgentListing,
  updateUser,
  addUser,
  getUser,
  getAgent,
  deleteUser,
  forgotPassword,
  resetPassword,
  getAllUserRoles,
  updateToken,
  updateProfile,
  getMyAccount,
  updateMyAccount,
  updatePassword,
  updateStatus,
  updateContactDetails,
  assignIdentity,
  getActiveInternalUsers,
  hasB2B2CEmergencyContact,
  updateB2B2CEmergencyContact,
  getUserLinkedAccounts,
  switchUser,
  getGlobalListing,
  getChildUserLocation,
  mfaSetup,
  mfaVerifyOtp,
  mfaSendEmailOtp
};
